<label class="ne-occasion">
  <div class="ne-label">{label}</div>
  <select on:change="{event => select(event)}">
    {#each options as option}
      <option
        value={option.title.state}
        selected={option.isSelected.state}>
        {option.title.state}
      </option>
    {/each}
  </select>
</label>

<script>
  export let options;
  export let label;
  export let select;
</script>
